import { render, staticRenderFns } from "./LabelValueRender.vue?vue&type=template&id=29609583&functional=true&v-slot%3A%5B%60label%60%5D=true"
import script from "./LabelValueRender.vue?vue&type=script&lang=js"
export * from "./LabelValueRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29609583')) {
      api.createRecord('29609583', component.options)
    } else {
      api.rerender('29609583', component.options)
    }
    module.hot.accept("./LabelValueRender.vue?vue&type=template&id=29609583&functional=true&v-slot%3A%5B%60label%60%5D=true", function () {
      api.rerender('29609583', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LabelValueRender.vue"
export default component.exports